export default __webpack_public_path__ + "static/media/document-upload-success-black.04e0c4c2.png";